export { AddPaymentMethodRouteModal as default } from 'features/payment/account';
